<template>
	<div>
		<az-toolbar>
			<template #actions>
				<botao-primario
					nome-botao="Novo"
					icone="add_circle"
					@click="abrirModalNovoModeloDocumento"
					v-az-auth="permissoes.modeloDocumentoCriar"
				></botao-primario>
			</template>
			<template #simpleSearch>
				<az-search
					:filter="filtro"
					simple-search-placeholder="Busque por titulo ou tipo"
					@simple-search="buscarDocumentoModeloListagemPorFiltro"
					@remove-filter="removerFiltros"
					v-az-auth="permissoes.modeloDocumentoListar"
					ref="componenteAzSearch"
					@clear="limparBuscaListagemPorFiltro"
				>
				</az-search>
			</template>
		</az-toolbar>
		<az-container class="listagem">
			<modelo-documento-listagem
				:modelos="modeloDocumentoListagem"
				:total-paginas="totalPaginasListagem"
				:total-itens="totalItensListagem"
				:paginacao="paginacaoListagem"
				@paginar="setPaginacaoModeloDocumentoListagem"
				@resetar-page="resetarPaginaModeloDocumentoListagem"
				@recarregar-listagem-modelo-documento="carregarModeloDocumentoListagem"
			></modelo-documento-listagem>
		</az-container>
		<novo-modelo-documento
			:exibir="exibirModalNovoModeloDocumento"
			@fechar-modal="abrirModalNovoModeloDocumento"
			@recarregar-listagem-modelo-documento="carregarModeloDocumentoListagem"
			@redirecionar-editor-texto="redirecionarPara"
		></novo-modelo-documento>
	</div>
</template>
<script>
import ModeloDocumentoListagem from '@/views/pages/configuracao/modelo-documento/listagem/ModeloDocumentoListagem.vue'
import { actionTypes, mutationTypes } from '@/core/constants'
import BotaoPrimario from '@/views/components/BotaoPrimario.vue'
import NovoModeloDocumento from '@/views/pages/configuracao/modelo-documento/novo-modelo/NovoModeloDocumento.vue'
import Paginacao from '@/core/store/default/paginacaoListagem'
import documentoMixin from '@/views/mixins/documento'

export default {
	name: 'modelo-documento',
	components: {
		NovoModeloDocumento,
		BotaoPrimario,
		ModeloDocumentoListagem,
	},
	mixins: [documentoMixin],
	data() {
		return {
			modeloDocumentoListagem: [],
			totalPaginasListagem: 0,
			totalItensListagem: 0,
			paginacaoListagem: Paginacao(['dataCriacao'], 25, 'DESC'),
			exibirModalNovoModeloDocumento: false,
		}
	},
	computed: {
		filtro: {
			get() {
				return this.$store.state.configuracao.modeloDocumento.filtro
			},
			set() {
				this.$store.commit(mutationTypes.CONFIGURACAO.MODELO_DOCUMENTO.SET_FILTRO_LISTAGEM)
			},
		},
	},
	async mounted() {
		await this.carregarModeloDocumentoListagem()
	},
	beforeDestroy() {
		this.$store.commit(mutationTypes.CONFIGURACAO.MODELO_DOCUMENTO.RESET_FILTRO_LISTAGEM)
		this.resetarPaginaModeloDocumentoListagem()
	},
	methods: {
		async carregarModeloDocumentoListagem() {
			const { itens, totalElements, totalPages } = await this.$store.dispatch(
				actionTypes.CONFIGURACAO.MODELO_DOCUMENTO.BUSCAR_MODELOS_DOCUMENTOS,
			)

			this.modeloDocumentoListagem = itens
			this.totalPaginasListagem = totalPages
			this.totalItensListagem = totalElements
		},
		async buscarDocumentoModeloListagemPorFiltro(searchText) {
			if (searchText) this.filtro.nome.value = searchText

			this.resetarPaginaModeloDocumentoListagem()
			await this.carregarModeloDocumentoListagem()
		},
		async removerFiltros(propriedade) {
			if (this.filtro[propriedade]) {
				this.filtro[propriedade].value = this.filtro[propriedade].default
			}
			await this.carregarModeloDocumentoListagem()
		},
		limparBuscaListagemPorFiltro() {
			this.$store.commit(mutationTypes.CONFIGURACAO.MODELO_DOCUMENTO.RESET_FILTRO_LISTAGEM)
		},
		setPaginacaoModeloDocumentoListagem(paginacao) {
			this.$store.commit(mutationTypes.CONFIGURACAO.MODELO_DOCUMENTO.SET_PAGINACAO_LISTAGEM, paginacao)
			this.carregarModeloDocumentoListagem()
		},
		resetarPaginaModeloDocumentoListagem() {
			this.$store.commit(mutationTypes.CONFIGURACAO.MODELO_DOCUMENTO.RESET_PAGINACAO_LISTAGEM)
		},
		abrirModalNovoModeloDocumento() {
			this.exibirModalNovoModeloDocumento = !this.exibirModalNovoModeloDocumento
		},
	},
}
</script>
<style lang="stylus" scoped></style>
